const ensureTrailingBackslash = (url) => {
  if (url.charAt(url.length - 1) === "/") {
    return url;
  }
  return url + "/";
};

const storageUrl = ensureTrailingBackslash(
  window.apartmentSearchConfig.storageUrl
);

const getStorageUrl = () => {
  return storageUrl;
};

export default { getStorageUrl };
